// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
import dayjs from "@lib/dayjs";
import {
  MeetingModeEnum,
  ReviewFormData,
} from "pages/CalendarsPage/SchedulingSection/form.types";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { isObjectEmpty } from "utils/helperFunction";
import { availabilitySlotsForApiPayload } from "../CreateMeetingPage";

const ReviewMeetingPoll = ({
  formData,
  isMeetingInvite,
}: {
  formData: ReviewFormData;
  isMeetingInvite: boolean;
}) => {
  const userDetails = useSelector((state: RootState) => state.auth.user);

  console.log("userDetails", userDetails);
  console.log("formData", formData);

  if (isObjectEmpty(formData)) return;

  return (
    <div className="flex flex-col flex-1 overflow-y-auto no-scrollbar min-h-0 pb-5">
      <div className="flex justify-between">
        {/* Meeting details */}
        <div className="flex flex-col gap-3.5 mt-9 border rounded-md p-5 w-[55%]">
          <span className="font-bold capitalize">{formData?.meetingTitle}</span>
          <div className="flex items-center">
            <span className="text-xs font-semibold">Job Title :&nbsp;</span>
            <span className="text-xs font-medium text-light-black">
              {formData?.jobDetails?.title}
            </span>
          </div>

          <div className="flex items-center">
            <span className="text-xs font-semibold">Meeting Type :&nbsp;</span>
            <span className="text-xs font-medium text-light-black">
              {MeetingModeEnum[formData?.meetingMode]}
            </span>
          </div>

          <div className="flex items-center">
            <span className="text-xs font-semibold">Meeting URL :&nbsp;</span>
            <span className="text-xs font-medium text-light-black">
              {formData?.url}
            </span>
          </div>

          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold">
              Meeting Description :&nbsp;
            </span>
            <span className="text-xs font-medium text-light-black">
              {formData?.meetingDescription}
            </span>
          </div>
        </div>
        {/* Organiser details */}
        <div className="flex flex-col gap-3.5 mt-9 border rounded-md p-5 w-[42%]">
          {/* Hiring company details */}
          <div className="flex flex-col w-full bg-light-white-700 rounded-md p-3">
            <span className="font-semibold text-xs text-primary">
              Organiser details:
            </span>
            <div className="flex items-center justify-between mt-2">
              <div className="flex items-center gap-3.5">
                {userDetails?.profilePic ? (
                  <img
                    src={userDetails?.profilePic}
                    className="w-10 h-10 rounded-md"
                  />
                ) : (
                  <div className="flex justify-center items-center w-10 h-10 rounded-full bg-gray-200 font-medium text-primary">
                    {userDetails?.companyName?.charAt(0)}
                  </div>
                )}
                <span className="text-xs font-medium text-primary">
                  {userDetails?.companyName}
                </span>
              </div>
              <span className="text-xs text-light-black">
                {userDetails?.refNo}
              </span>
            </div>
            {/* Hiring team members */}
            {formData?.hiringTeamMembers?.length ? (
              <div className="flex flex-col border-t mt-3.5 pt-3.5 gap-3.5">
                <span className="font-semibold text-xs text-primary">
                  Hiring team members
                </span>
                <div className="flex flex-col gap-2">
                  {formData?.hiringTeamMembers?.map(() => {
                    return (
                      <div className="flex items-center gap-3.5">
                        <img src={ProfileImg} className="w-6 h-6 rounded-md" />
                        <span className="text-xs font-medium text-light-black">
                          Hiring company
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
          {/* Candidate details */}
          <div className="flex flex-col w-full bg-light-white-700 rounded-md p-3">
            <span className="font-semibold text-xs text-primary">
              Candidate details:
            </span>
            <div className="flex items-center justify-between mt-2">
              <div className="flex items-center gap-3.5">
                {formData?.candidateDetails?.profilePic ? (
                  <img
                    src={formData?.candidateDetails?.profilePic}
                    className="w-10 h-10 rounded-md"
                  />
                ) : (
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 font-semibold text-primary">
                    {formData?.candidateDetails?.fullName?.charAt(0)}
                  </div>
                )}
                <div className="flex flex-col">
                  <span className="text-xs font-medium text-primary">
                    {formData?.candidateDetails?.fullName}
                  </span>
                  <span className="text-xs text-primary">
                    {formData?.candidateDetails?.email}
                  </span>
                </div>
              </div>
              <span className="text-xs text-light-black">
                {formData?.candidateDetails?.refNo}
              </span>
            </div>
          </div>
          {/* Recruitment agent details */}
          {/* {selectedRecruiter ? (
          <div className="flex flex-col w-full bg-light-white-700 rounded-md p-3">
            <span className="font-semibold text-xs text-primary">
              Recruitment agent details:
            </span>
            <div className="flex items-center justify-between mt-2">
              <div className="flex items-center gap-3.5">
                {selectedRecruiter?.logo ? (
                  <img
                    src={selectedRecruiter?.logo}
                    className="w-10 h-10 rounded-md"
                  />
                ) : (
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 font-semibold text-primary">
                    {selectedRecruiter?.name?.charAt(0)}
                  </div>
                )}
                <div className="flex flex-col">
                  <span className="text-xs font-medium text-primary">
                    {selectedRecruiter?.name}
                  </span>
                </div>
              </div>
              <span className="text-xs text-light-black">
                {selectedRecruiter?.refNo}
              </span>
            </div>
          </div>
        ) : null} */}
        </div>
      </div>

      {isMeetingInvite ? (
        <div className="flex flex-col mt-4 gap-3">
          <div className="flex items-center">
            <span className="text-xs font-semibold">
              Meeting Duration :&nbsp;
            </span>
            <span className="text-xs font-medium text-light-black">
              {formData?.meetingDuration?.label}
            </span>
          </div>
          <div className="flex">
            <span className="text-xs font-semibold">
              Meeting Timing :&nbsp;
            </span>
            <div className="">
              {Object.entries(formData?.availabilitySlots).map(
                ([date, slots]) => (
                  <div key={date} className="flex flex-col pl-3 gap-1">
                    {slots.map((slot, idx) => (
                      <span
                        key={idx}
                        className="font-medium text-xs text-light-black"
                      >
                        {dayjs(slot?.startTime).format("dddd MMM Do")},{" "}
                        {dayjs(slot?.startTime).format("h:mm A")} -{" "}
                        {dayjs(slot?.endTime).format("h:mm A")}
                      </span>
                    ))}
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      ) : (
        // Meeting availability slots
        <div className="flex flex-col mt-4 gap-3 min-h-0">
          <div className="flex flex-col min-h-0">
            <span className="text-sm font-semibold">
              Meeting Timings :&nbsp;
            </span>
            <div className="flex flex-col pt-2.5 gap-3 min-h-0 overflow-y-scroll no-scrollbar">
              {availabilitySlotsForApiPayload(formData?.availabilitySlots).map(
                (slot, slotIndex) => {
                  return (
                    <div className="flex items-center gap-4">
                      <div className="flex flex-col items-center justify-center bg-primary text-white rounded-md py-1 px-4 cursor-pointer">
                        <span className="font-bold text-sm">
                          {dayjs(slot?.startTime).format("ddd")}
                        </span>
                        <span className="font-semibold text-[0.6rem]">
                          {dayjs(slot?.startTime).format("MMM-DD")}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="border rounded-md justify-center items-center flex py-2.5 w-24 font-medium text-sm">
                          {dayjs(slot?.startTime).format("HH:mm")}
                        </div>
                        <div className="h-px w-5 bg-gray-300" />
                        <div className="border rounded-md justify-center items-center flex py-2.5 w-24 font-medium text-sm">
                          {dayjs(slot?.endTime).format("HH:mm")}
                        </div>
                      </div>
                    </div>
                  );
                }
              )}
              {/* {Object.entries(formData?.availabilitySlots).map(
                ([date, slots]) => (
                  <div key={date} className="flex flex-col gap-5">
                    {slots.map((slot, idx) => (
                      <span
                        key={idx}
                        className="font-medium text-xs text-light-black"
                      >
                        {dayjs(slot?.startTime).format("dddd MMM Do")},{" "}
                        {dayjs(slot?.startTime).format("h:mm A")} -{" "}
                        {dayjs(slot?.endTime).format("h:mm A")}
                      </span>
                    ))}
                  </div>
                )
              )} */}
            </div>
            {/* <div className="space-y-2 mt-0.5">
              {Object.entries(formData?.availabilitySlots)
                .sort(
                  ([dateA], [dateB]) =>
                    new Date(dateA).getTime() - new Date(dateB).getTime()
                )
                .map(([date, slots]) => (
                  <div key={date} className="rounded-md px-2">
                    <span className="font-semibold text-xs text-light-black">
                      {new Date(date).toDateString()}
                    </span>
                    <div className="flex flex-col pl-3 gap-1">
                      {slots.map((slot, idx) => (
                        <span
                          key={idx}
                          className="font-medium text-xs text-light-black"
                        >
                          - {dayjs(slot?.startTime).format("h:mm a")} -{" "}
                          {dayjs(slot?.endTime).format("h:mm a")}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};
export default ReviewMeetingPoll;
